import React, { FC } from 'react';
import Navbar from 'components/Navbar';
import Grommet from 'components/Grommet';

import { grommet } from 'grommet';
import { deepMerge } from 'grommet/utils';
import themeConfig from 'helpers/theme.config';

const onfleetTheme = deepMerge(grommet, themeConfig);

const Layout: FC = ({ children }) => {
  return (
    <Grommet className="App" theme={onfleetTheme} background="dark-color">
      <Navbar />
      <main>{children}</main>
    </Grommet>
  );
};

export default Layout;
